import React from 'react'
import { Button, Modal } from 'react-bootstrap'

import { isOffice } from '../../../lib/helpers/officeHelpers'
import ContextInformation = Office.ContextInformation

interface DiagnosticModalProps {
  show: boolean
  onHide: () => void
}

// Type definitions for Office context objects
interface OfficeRequirements {
  _setMap?: {
    _sets?: Record<string, string | number | boolean>
  }
}

const DiagnosticModal: React.FC<DiagnosticModalProps> = ({ show, onHide }) => {
  const getRequirementSets = (): string => {
    if (!isOffice()) return 'Office.js not available'

    try {
      // Access the internal _setMap._sets object
      const setMap = (Office?.context.requirements as OfficeRequirements)
        ._setMap?._sets
      if (!setMap || typeof setMap !== 'object') {
        return 'No requirement sets found'
      }

      const sets: string[] = []
      for (const [key, value] of Object.entries(setMap)) {
        sets.push(`${key}: ${value}`)
      }

      return sets.length > 0 ? sets.join(', ') : 'No requirement sets found'
    } catch (error) {
      return `Error accessing requirement sets: ${error}`
    }
  }

  const getDiagnosticData = () => {
    const getOfficeValue = (path: keyof ContextInformation) => {
      if (!isOffice()) return 'Office.js not available'
      try {
        return (
          (Office?.context.diagnostics?.[path] as string) || 'Not available'
        )
      } catch (error) {
        return `Error: ${error}`
      }
    }

    return {
      host: getOfficeValue('host'),
      version: getOfficeValue('version'),
      platform: getOfficeValue('platform'),
      requirementSets: getRequirementSets(),
      userAgent: navigator.userAgent,
      cookieEnabled: navigator.cookieEnabled,
    }
  }

  const renderDiagnosticItem = (title: string, content: string | boolean) => (
    <div className="mb-3">
      <h6 className="mb-2">{title}</h6>
      <div className="p-2 bg-light border rounded">{String(content)}</div>
    </div>
  )

  const data = getDiagnosticData()

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>🔧 Office Add-in Diagnostics</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {renderDiagnosticItem('Host', data.host)}
        {renderDiagnosticItem('Version', data.version)}
        {renderDiagnosticItem('Platform', data.platform)}
        {renderDiagnosticItem('Requirement Sets', data.requirementSets)}
        {renderDiagnosticItem('userAgent', data.userAgent)}
        {renderDiagnosticItem('cookieEnabled', data.cookieEnabled)}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DiagnosticModal
